import React from 'react';
import styled, { keyframes } from '../../styles/styled-components';
import { Glyphicon, GlyphiconProps } from '../icons';

export type LoaderProps = { text: string } & Stylable;

export const Loader = ({ text, ...rest }: LoaderProps) => (
  <LoaderOverlay {...rest}>
    <LoaderIcon size="big" />
    {text}
  </LoaderOverlay>
);

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

export const LoaderIcon = ({ ...rest }: Omit<GlyphiconProps, 'glyph'>) => (
  <CirclingIcon glyph="loader" {...rest} />
);

const CirclingIcon = styled(Glyphicon)`
  animation: ${spin} 2s linear infinite;
`;

const LoaderOverlay = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background-color: ${p => p.theme.whiteText};
`;
